<template>
  <div class="content-page mobile-app">
    <div class="mian-page">
      <div class="title-page">案件列表</div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <div class="search">
            <van-icon name="revoke" size="24" class="back" @click="$router.push('/m-selectType')"/>
            <el-input v-model="keywords" placeholder="请输入案号、申请人、被申请人等关键词进行搜索" @change="searchFn"></el-input>
          </div>
          <van-tabs v-model="active" @change="tabChange" style="margin-top: 5px">
            <van-tab title="申请信息"></van-tab>
            <van-tab title="案件信息"></van-tab>
          </van-tabs>
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list class="list-section" v-model="loading" :finished="finished" finished-text="暂无更多案件" @load="onLoad">
            <div class="list-item" v-for="(item,index) in tableData" :key="index" @click="goDetail(item)">
              <div class="top-btn">
                <div
                  class="item-status"
                  :style="{background: '#1C72FD'}"
                >{{item.wssqCaseStatusName || item.caseStatusName || '-'}}</div>
                <!-- 申请中状态 -->
                <!-- applyStatus: 0-未发起，1-申请中，2-申请通过，3-申请驳回 -->
                <div
                  v-if="item.applyStatus === 1 && searchType == 0"
                  class="review-status-wrapper"
                  @click.stop
                >
                  <div class="item-status" style="background: #1C72FD" @click="toggleReviewTip(index)">申请中</div>
                  <div v-if="item.showReviewTip" class="review-tip" @click.stop>您的阅卷申请已提交，请耐心等待复议机关审批；</div>
                </div>
                <!-- 申请驳回状态 -->
                <div
                 v-if="item.caseStatus === 6 && item.applyStatus === 3 && item.isAllocateHandleUser === 1"
                  class="item-status" 
                  style="background: #1C72FD;" 
                  @click.stop="openRejectDialog(item)"
                >申请驳回</div>
              </div>
              <div class="item-title">{{item.inquireNo}}</div>
              <div class="item-title" v-if="searchType != 1">{{item.caseNo}}</div>
              <div class="item-cell">
                <div class="item-cell-label">申请人：</div>
                <div class="item-cell-content">{{item.applicantName || ''}}</div>
              </div>
              <div class="item-cell">
                <div class="item-cell-label">被申请人：</div>
                <div class="item-cell-content">{{item.respondentName || ''}}</div>
              </div>
              <div class="item-cell">
                <div class="item-cell-label">复议机关：</div>
                <div class="item-cell-content">{{item.reconsiderationAgencyName || ''}}</div>
              </div>
              <div class="item-cell" v-if="searchType != 1">
                <div class="item-cell-label">案由：</div>
                <div class="item-cell-content">{{item.caseCause || ''}}</div>
              </div>
              <div class="item-cell" v-if="item.tcEndTime">
                <div
                  class="item-cell-label"
                  :class="{ 'bzlabel': item.tcEndTime }"
                >到达时间：</div>
                <div
                  class="item-cell-content"
                >{{item.tcEndTime}}</div>
              </div>
              <div class="item-cell" v-else>
                <div
                  class="item-cell-label"
                >收案时间：</div>
                <div
                  class="item-cell-content"
                >{{item.filingTime}}</div>
              </div>
              <div class="item-foot" v-if="oprate == 'search' && searchType != 1">
                <div
                  v-if="oprate == 'search' && item.correctionState == 1 && item.wssqCaseStatus == 2 && indexofStr(item.caseTips,'ajichz') == -1"
                  class="add-check-btn"
                  :class="{ 'add-check-btn-disabled': item.correctionSyncState === 0 }"
                  @click.stop="newCase(item, 1)"
                >补正</div>
                <div v-if="oprate == 'search' && item.opinionBtn" class="add-btn" @click.stop="openOpinionDialog(item)">听取意见</div>
                <div v-if="item.wssqCaseStatus == '3'" class="add-btn" :class="{ 'add-btn-disabled': indexofStr(item.caseTips,'ajbc') != -1 }" @click.stop="newCase(item, 2)">补充</div>
                <div v-if="item.caseStatus === 6 && item.applyStatus === 0 && item.isAllocateHandleUser === 1" class="add-check-btn" @click.stop="openReviewApplication(item)">申请阅卷</div>
                <div v-if="item.caseStatus === 6 && item.applyStatus === 2 && item.isAllocateHandleUser === 1" class="add-check-btn" @click.stop="openOnlineReview(item)">在线阅卷</div>
              </div>
              <div class="item-foot" v-if="oprate == 'revokeApply'">
                <div class="add-check-btn" @click.stop="revoke(item)">撤回</div>
              </div>
            </div>
          </van-list>
          </van-pull-refresh>
        </div>
        <revokeTip
          :caseOrderNo="caseOrderNo"
          :applicantInfo="applicantInfo"
          ref="revokeTip"
          @openCh="openCh"
        />
        <!--   撤回书预览   -->
        <el-dialog
          :fullscreen="true"
          v-if="fileReviewDialog"
          :visible.sync="fileReviewDialog"
          title="撤回书预览"
          :close-on-click-modal="false"
          :show-close="true"
        >
          <div style="max-height: 80%; overflow-y: auto">
            <img v-for="(item,index) in imgList" :key="index" :src="item.fileBaseUri" />
          </div>
          <span slot="footer">
            <el-button type="primary" @click="doSubmit">撤回</el-button>
          </span>
        </el-dialog>

        <!-- 补正前提示 -->
        <van-dialog v-model="show" title="补正提示"  :before-close="onBeforeClose" @confirm="tipconfim" :class="downNumber > 0 ? 'diaslbed' : ''" show-cancel-button :confirm-button-text="`确认${downNumber > 0 ? `（${downNumber}）` : ''}`">
          <div style="padding:10px 20px;line-height: 25px;text-indent: 1em"> 1、你的复议申请已通过书面方式补正，请在收到书面补正通知后，按照书面补正通知的指引进行补正。</div>
          <div style="padding:10px 20px;line-height: 25px;text-indent: 1em">2、如你选择通过本系统进行补正，补正界面文本框中显示的内容仅为对你之前提交复议申请书的摘要，并不是你复议申请书的全部内容。你可在补正界面对文本框内容进行修改，补正复议申请书内容以你最终提交的为准。 </div>
       </van-dialog>

        <!-- 申请阅卷弹窗 -->
        <review-application
          v-if="reviewApplicationShow"
          ref="reviewApplication"
          :case-order-no="reviewApplicationItem ? reviewApplicationItem.caseOrderNo : ''"
          @confirm="handleReviewApplicationConfirm"
        />

        <!-- 在线阅卷弹窗 -->
        <online-review
          v-if="onlineReviewShow"
          ref="onlineReview"
          :case-order-no="onlineReviewItem ? onlineReviewItem.caseOrderNo : ''"
          :signature-name="loginName"
          :detail-info="{ caseInfo: onlineReviewItem || {} }"
          @confirm="handleOnlineReviewConfirm"
        />

        <!-- 驳回理由弹窗 -->
        <van-popup
          v-model="rejectDialogShow"
          position="center"
          :style="{ borderRadius: '16px', overflow: 'hidden', width: '85vw', maxWidth: '500px' }"
          :close-on-click-overlay="true"
          @close="closeRejectDialog"
        >
          <div class="reject-dialog">
            <div class="reject-dialog-header">
              <div class="reject-dialog-close" @click="closeRejectDialog">
                <van-icon name="cross" size="20" color="#999" />
              </div>
            </div>
            <div class="reject-dialog-content">
              <!-- <div class="title">您的阅卷申请被驳回，</div> -->
              <div>{{rejectReason}}</div>
            </div>
          </div>
        </van-popup>
        <!-- 听取意见弹窗 -->
        <van-dialog
          v-model="opinionDialogVisible"
          :show-cancel-button="true"
          :close-on-click-overlay="false"
          :class-name="'opinion-dialog'"
          :before-close="beforeOpinionClose"
          @cancel="opinionDialogVisible = false"
        >
          <div class="opinion-dialog-body">
            <div class="opinion-question">
              <div class="opinion-tip-question">请就您的复议案件发表意见。</div>
              <div class="opinion-question-content">询问：{{ latestOpinion.question || '-' }}</div>
            </div>
            <div class="opinion-form-item">
              <div class="opinion-label">
                <span class="required-star">*</span>请填写书面意见：
              </div>
              <van-field
                v-model="opinionForm.text"
                type="textarea"
                rows="6"
                maxlength="1000"
                placeholder="请在此填写您对复议案件的意见（最多1000字）"
                show-word-limit
                class="opinion-textarea"
              />
            </div>
            <div class="opinion-form-item opinion-upload-item">
              <input
                ref="fileInput"
                type="file"
                accept=".doc,.docx,.pdf"
                style="display: none"
                @change="handleFileSelect"
              />
              <van-button type="info" class="opinion-upload-button" @click="triggerFileSelect">上传附件</van-button>
              <div class="opinion-upload-tip">
                (附件仅允许上传一个.doc、.pdf类型的文件，且文件大小需在20M以内)
              </div>
            </div>
            <div class="opinion-form-item">
              <div v-if="opinionFileList.length > 0" class="file-list">
                <div class="file-item" v-for="(file, index) in opinionFileList" :key="index">
                  <span class="file-name">{{ file.name }}</span>
                  <span v-if="file.uploading" class="file-status">上传中...</span>
                  <span v-else-if="file.fileId" class="file-status success">上传成功</span>
                  <van-icon name="cross" class="file-delete" @click="removeFile(index)" />
                </div>
              </div>
            </div>
            <div class="opinion-form-item">
              <van-checkbox v-model="opinionForm.checked" class="opinion-checkbox" shape="square">
                我确认以上内容真实，并同意复议机关据此审理本案。
              </van-checkbox>
            </div>
          </div>
        </van-dialog>

        <!-- 签名弹窗：复用已有组件 -->
        <singDialog
          ref="singDialogOpinion"
          signType="opinion"
          :opera="1"
          :detailInfo="{ caseOrderNo: currentOpinionRow.caseOrderNo }"
          @signature-submit="handleOpinionSigned"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@api/api";
import { Dialog } from "vant";
import revokeTip from "./DetailCase/components/revokeTip";
import reviewApplication from "./components/reviewApplication.vue";
import onlineReview from "./components/onlineReview.vue";
import singDialog from "@/components/singDialog/singDialog";
export default {
  name: "caseList",
  data() {
    return {
      reviewApplicationShow: false,
      reviewApplicationItem: null,
      onlineReviewShow: false,
      onlineReviewItem: null,
      rejectDialogShow: false,
      rejectReason: '',
      scrollTop: 0,
      searchType: this.$route.query.searchType ? Number(this.$route.query.searchType) : 1,
      active: this.$route.query.searchType ? (Number(this.$route.query.searchType) === 1 ? 0 : 1) : 0,
      tableData: [],
      imgList: [],
      show:false,
      downNumber: 5, // 倒数字
      identificationCard: this.$route.query.identificationCard || "",
      phone: this.$route.query.phone || "",
      applicantCategory: this.$route.query.applicantCategory || "",
      loginName: this.$route.query.loginName || "",
      currentPage: 1,
      refreshing:false,
      pageSize: 10,
      loading: false,
      statusTrans: ["", "#468cd8", "#5a84f7", "#58c1b3"],
      finished: false,
      keywords: "",
      search: {
        caseNo: "",
        respondentName: "",
        reconsiderationAgency: "",
        caseCause: ""
      },
      applicantInfo: [
        {
          name: ""
        }
      ],
      caseOrderNo: "",
      total: 0,
      writList: [],
      fileReviewDialog: false,
      oprate: localStorage.getItem("oprate"),
      // 听取意见相关
      opinionDialogVisible: false,
      currentOpinionRow: {},
      latestOpinion: {
        question: '',
        listenOpinionId: '',
      },
      opinionForm: {
        text: '',
        checked: false
      },
      opinionFileList: []
    };
  },
  components: {
    revokeTip,
    reviewApplication,
    onlineReview,
    singDialog
  },
  watch: {
    writList: function(newVal) {
      if (newVal) {
        newVal.map(item => {
          item.fileBaseUri = "data:image/png;base64," + item.fileBaseUri;
        });
        this.imgList = newVal;
      }
    }
  },
  mounted() {
    this.getlist();
  },
  methods: {
    // 
    tabChange(index) {
      console.log(index);
      // 重置状态
      this.tableData = []
      this.currentPage = 1
      this.finished = false
      this.loading = true
      if (index == 0) {
        this.searchType = 1
      } else {
        this.searchType = 0
      }

      this.getlist();
    },
    /**
     * 阻止模态框关闭
     * @description 根据操作判断
     * @param {String} action - 是确定还是取消
     * @param {Function} done - 操作函数
     * @return Function
     */
    onBeforeClose(action, done) {
      // 点击了确定按钮
        if (action === "confirm") {
          // if()...也可以加入一些条件
          if(this.downNumber > 0){
            done(false)
          } else {
            done(true); //关闭弹窗， true可以省略

          }
        }
        // 点击了取消按钮
        else {
            done(true); //关闭弹窗, true可以省略
        }
    },
    onRefresh() {
      // 清空列表数据
      this.tableData = []
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.currentPage = 1
      this.getlist();
    },
    // 加载
    onLoad(){
      if(this.tableData.length < this.total){
        this.currentPage += 1
        this.getlist();
      }
      
    },
    // 撤回
    doSubmit() {
      this.$confirm("是否确认撤回申请书无误?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const withdrawSource = +this.$route.query.searchType + 1
        Api.revoke({
          caseSource: 4,
          caseOrderNo: this.caseOrderNo,
          inquireNo: withdrawSource === 2 ? this.detailInfo.inquireNo : '',
          withdrawSource
        }).then(({ data }) => {
          this.fileReviewDialog = false;
          if (data.code == 0) {
            this.$alert(
              "您已确认撤回申请，后续将由工作人员进行确认，您可以通过“我要查询”模块查询案件进展",
              "提示",
              {
                confirmButtonText: "确定",
                callback: action => {
                  this.getlist();
                }
              }
            );
          }
        });
      });
    },
    openCh(data) {
      console.log(data);
      this.fileReviewDialog = true;
      console.log(data.data.showImgPathList);
      this.writList = data.data.showImgPathList;
    },
    revoke(item) {
      this.$router.push({
        name: "MDetailCase",
        query: {
          from: "list",
          isRevoke: 1,
          searchType: this.searchType,
          number: item.caseOrderNo
        }
      });
    },
     // 倒计时
    startDownNumber () {
      this.downNumber = 5
      var times = setInterval(() => {
        console.log('====================================')
        this.downNumber--
        if (this.downNumber <= 0) {
          this.isShow = true
          clearInterval(times)
        }
      }, 1000)
    },
    tipconfim(){
      if(this.downNumber > 0 ){
         return;
      }
      this.show = false
      Api.correctionCheck({
          caseOrderNo: this.caseOrderNo
        }).then(({ data }) => {
          if (data.code == 0) {
            
            this.$router.push({
              name: "MNewCase",
              query: {
                name: "caseList",
                number: this.caseOrderNo,
                opera: 1
              }
            });
          }
        });
    },
    newCase(item, opera) {
      if (opera == 1) {
        // 已提交补正材料：拦截提示
        if (item.correctionSyncState === 0) {
          Dialog.alert({
            title: "提示",
            message: "您已提交补正材料，请耐心等候",
            confirmButtonText: "确定"
          });
          return;
        }
        // 点击补正校验是否48小时
        this.show = true
        this.caseOrderNo = item.caseOrderNo
        this.startDownNumber()

      } else {
        // 补充
        if (this.indexofStr(item.caseTips, "ajbc") != -1) {
          Dialog.alert({
            title: "提示",
            message: "你已提交过补充材料",
            confirmButtonText: "确定"
          });
          return;
        }
        this.$router.push({
          name: "MNewCase",
          query: {
            name: "caseList",
            number: item.caseOrderNo,
            opera
          }
        });
      }
    },
    searchFn() {
      this.tableData = []
      this.currentPage = 1;
      this.getlist();
    },
    reset() {
      this.currentPage = 1;
      this.search = {
        caseNo: "",
        respondentName: "",
        reconsiderationAgency: "",
        caseCause: ""
      };
      this.getlist();
    },
    goDetail(item) {
      this.$router.push({
        name: "MDetailCase",
        query: {
          from: "list",
          number: item.caseOrderNo,
          searchType: this.searchType
        }
      });
    },
    currentChange(val) {
      this.currentPage = val;
      this.getlist();
    },
    sizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getlist();
    },
    indexofStr(str1, str2) {
      return str1 ? str1.indexOf(str2) : -1;
    },
    
    // 切换阅卷提示显示/隐藏
    toggleReviewTip(index) {
      const item = this.tableData[index];
      this.$set(item, 'showReviewTip', !item.showReviewTip);
    },
    
    // 打开申请阅卷弹窗
    openReviewApplication(item) {
      this.reviewApplicationItem = item;
      this.reviewApplicationShow = true;
      this.$nextTick(() => {
        if (this.$refs.reviewApplication) {
          this.$refs.reviewApplication.open();
        }
      });
    },
    
    // 关闭申请阅卷弹窗
    closeReviewApplication() {
      this.reviewApplicationShow = false;
      this.reviewApplicationItem = null;
    },
    
    // 确认申请阅卷
    handleReviewApplicationConfirm(data) {
      console.log('申请阅卷确认', data);
      this.closeReviewApplication();
      // 切换到案件信息选项卡
      this.active = 1;
      this.searchType = 0;
      // 刷新列表
      this.onRefresh();
    },
    
    // 打开驳回理由弹窗
    openRejectDialog(item) {
      this.rejectReason = item.rejectReason || '123';
      this.$nextTick(() => {
        this.rejectDialogShow = true;
      });
    },
    
    // 关闭驳回理由弹窗
    closeRejectDialog() {
      this.rejectDialogShow = false;
      this.rejectReason = '';
    },
    
    // 打开在线阅卷弹窗
    openOnlineReview(item) {
      // 判断 reviewFilesIsRead 字段
      // 如果为 0，打开 onlineReview 和 signCanvas 组件
      // 如果为 1，直接跳转到文件列表页 reviewList
      if (item.reviewFilesIsRead === 0 || item.reviewFilesIsRead === '0') {
        // 未阅卷，需要签名
        this.onlineReviewItem = item;
        this.onlineReviewShow = true;
        this.$nextTick(() => {
          if (this.$refs.onlineReview) {
            this.$refs.onlineReview.open();
          }
        });
      } else if (item.reviewFilesIsRead === 1 || item.reviewFilesIsRead === '1') {
        // 已阅卷，跳转到文件列表页
        // 格式化申请时间
        const filingTime = item.filingTime || item.filingTimeFormat || ''
        let filingTimeStr = ''
        if (filingTime) {
          const date = new Date(filingTime.replace(/-/g, '/'))
          const year = date.getFullYear()
          const month = date.getMonth() + 1
          const day = date.getDate()
          filingTimeStr = `${year}年${month}月${day}日`
        }
        
        // 跳转到阅览列表页面，传递申请人信息和申请时间
        const applicantName = encodeURIComponent(item.applicantName || '')
        
        this.$router.push({
          name: 'MReviewList',
          query: {
            caseOrderNo: item.caseOrderNo,
            applicantName: applicantName,
            filingTime: encodeURIComponent(filingTimeStr)
          }
        }).catch(err => {
          console.error('跳转失败', err);
          this.$toast.fail('跳转失败，请重试');
        })
      } else {
        // 默认情况，打开 onlineReview 组件
        this.onlineReviewItem = item;
        this.onlineReviewShow = true;
        this.$nextTick(() => {
          if (this.$refs.onlineReview) {
            this.$refs.onlineReview.open();
          }
        });
      }
    },
    
    // 关闭在线阅卷弹窗
    closeOnlineReview() {
      this.onlineReviewShow = false;
      this.onlineReviewItem = null;
    },
    
    // 确认在线阅卷
    handleOnlineReviewConfirm(data) {
      console.log('在线阅卷确认', data);
      
      // 先获取当前案件信息（在关闭弹窗之前）
      const item = this.onlineReviewItem;
      if (!item) {
        this.$toast.fail('案件信息不存在');
        this.closeOnlineReview();
        return;
      }
      
      // 格式化申请时间
      const filingTime = item.filingTime || item.filingTimeFormat || ''
      let filingTimeStr = ''
      if (filingTime) {
        const date = new Date(filingTime.replace(/-/g, '/'))
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        filingTimeStr = `${year}年${month}月${day}日`
      }
      
      // 跳转到阅览列表页面，传递申请人信息和申请时间
      const applicantName = encodeURIComponent(item.applicantName || '')
      
      // 跳转后弹窗会自动关闭，所以不需要手动关闭
      this.$router.push({
        name: 'MReviewList',
        query: {
          caseOrderNo: item.caseOrderNo,
          applicantName: applicantName,
          filingTime: encodeURIComponent(filingTimeStr)
        }
      }).catch(err => {
        console.error('跳转失败', err);
        this.$toast.fail('跳转失败，请重试');
        // 跳转失败时才关闭弹窗
        this.closeOnlineReview();
      })
    },
    // 打开听取意见弹窗
    openOpinionDialog(item) {
      this.currentOpinionRow = item;
      Api.getLatestOpinion({ caseOrderNo: item.caseOrderNo }).then(({ data }) => {
        if (data.code == 0 && data.data) {
          this.latestOpinion = {
            question: data.data.informContent || '-',
            listenOpinionId: data.data.listenOpinionId || ''
          };
        } else {
          this.latestOpinion = {
            question: '-',
            listenOpinionId: '',
          };
        }
      }).catch(() => {
        this.latestOpinion = {
          question: '-',
          listenOpinionId: '',
        };
      });
      this.opinionForm = {
        text: '',
        checked: false
      };
      this.opinionFileList = [];
      this.opinionDialogVisible = true;
    },
    triggerFileSelect() {
      if (this.opinionFileList.length > 0) {
        this.$toast('只能上传一个文件，请先删除已有文件');
        return;
      }
      this.$refs.fileInput.click();
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      if (this.opinionFileList.length > 0) {
        this.$toast('只能上传一个文件，请先删除已有文件');
        event.target.value = '';
        return;
      }
      const ext = file.name.split('.').pop().toLowerCase();
      const allow = ['doc', 'docx', 'pdf'];
      if (!allow.includes(ext)) {
        this.$toast('仅支持上传 WORD 或 PDF 文件');
        event.target.value = '';
        return;
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$toast('文件大小需在20M以内');
        event.target.value = '';
        return;
      }
      this.opinionFileList = [{
        file: file,
        name: file.name,
        size: file.size,
        uploading: true // 标记正在上传
      }];
      event.target.value = '';
      const formData = new FormData();
      formData.append('file', file);
      formData.append('caseOrderNo', this.currentOpinionRow.caseOrderNo);
      formData.append('kindType', '7'); // 7表示听取意见附件
      const loadingToast = this.$toast.loading({
        message: '文件上传中...',
        forbidClick: true,
        duration: 0
      });
      Api.appletsUpload(formData)
        .then(({ data }) => {
          console.log('上传响应:', data);
          if (data && data.data && data.data.id) {
            if (this.opinionFileList.length > 0) {
              this.opinionFileList[0].fileId = data.data.id;
              this.opinionFileList[0].uploading = false;
            }
            this.$toast.success('文件上传成功');
          } else {
            console.error('上传响应数据结构异常:', data);
            throw new Error('文件上传失败：响应数据格式错误');
          }
        })
        .catch((error) => {
          console.error('文件上传失败:', error);
          this.$toast('文件上传失败，请重试');
          this.opinionFileList = [];
        })
        .finally(() => {
          if (loadingToast) {
            loadingToast.clear();
          }
        });
    },
    removeFile(index) {
      if (this.opinionFileList[index] && this.opinionFileList[index].uploading) {
        this.$toast('文件正在上传中，请稍候再删除');
        return;
      }
      this.opinionFileList.splice(index, 1);
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    beforeOpinionClose(action, done) {
      if (action === 'confirm') {
        if (!this.opinionForm.text || !this.opinionForm.text.trim()) {
          this.$toast('请填写书面意见');
          done(false); // 阻止关闭
          return;
        }
        if (this.opinionForm.text.length > 1000) {
          this.$toast('书面意见最多支持1000字');
          done(false); // 阻止关闭
          return;
        }
        if (!this.opinionForm.checked) {
          this.$toast('请先勾选确认以上内容真实');
          done(false); // 阻止关闭
          return;
        }
        done(true); // 允许关闭
        this.$nextTick(() => {
          if (this.$refs.singDialogOpinion) {
            this.$refs.singDialogOpinion.open();
          }
        });
      } else {
        done(true);
      }
    },
    async handleOpinionSigned(event) {
      console.log('opinion signed', event);
      try {
        // 获取已上传的文件ID（文件已在handleFileSelect中上传）
        let fileId = '';
        if (this.opinionFileList.length > 0) {
          // 检查文件是否还在上传中
          if (this.opinionFileList[0].uploading) {
            this.$toast('文件正在上传中，请稍候...');
            return;
          }
          // 获取已上传的文件ID
          fileId = this.opinionFileList[0].fileId || '';
        }
        const params = {
          caseOrderNo: this.currentOpinionRow.caseOrderNo,
          listenOpinionId: this.latestOpinion.listenOpinionId,
          applicantId: this.identificationCard,
          informContent: this.opinionForm.text,
          file: fileId || '',
          signPath: event.uploadResult?.data?.evidencePath || ''
        };
        const { data } = await Api.addOpinion(params);
        if (data.code == 0) {
          this.$toast.success('提交成功');
          this.opinionForm = {
            text: '',
            checked: false
          };
          this.opinionFileList = [];
          this.getlist();
        } else {
          if (data.msg && !['系统异常', '后台服务异常'].includes(data.msg)) {
            this.$toast(data.msg);
          } else if (!data.msg) {
            this.$toast('提交失败，请重试');
          } else {
            console.error('Error:', data.msg);
          }
        }
      } catch (error) {
        console.error('提交听取意见失败:', error);
        this.$toast('提交失败，请重试');
      }
    },
    getlist() {
      const {
        identificationCard,
        phone,
        applicantCategory,
        loginName,
        oprate
      } = this;
      let params = {
        loadMore: true,
        keywords: this.keywords,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      };
      let filter = {
        identificationCard,
        applicantName: loginName,
        phone
      };

      if (this.searchType == 1) {
        filter.searchType = 1
      }

      if (oprate == "revokeApply") {
        filter.isToWithdraw = "1";
      }

      if (oprate == "search") {
        filter.isToWithdraw = "";
      }
      // 开始加载时设置loading状态
      this.loading = true;
      Api.getCaseList({
        applicantCategory,
        ...filter,
        ...params
      }).then(({ data }) => {
        console.log(data);
        let list = [];
        list = data.data ? data.data.list || [] : []
        list.forEach(item => {
          if (item.reconsiderationAgencyName) {
            item.reconsiderationAgencyName = item.reconsiderationAgencyName.startsWith(
              "上海市"
            )
              ? item.reconsiderationAgencyName
              : "上海市" + item.reconsiderationAgencyName;
          }
          // formatDate
          item.tcEndTime = item.tcEndTime
            ? this.$moment(item.tcEndTime).format("yyyy-MM-DD")
            : "";
          item.filingTime = this.$moment(item.filingTime).format("yyyy-MM-DD")
        });
        this.loading = false
        this.tableData = this.tableData.concat(list);
        this.total = data.data ? data.data.total || 0 : 0;
        this.refreshing = false
        if(this.total == this.tableData.length){
          this.finished = true
        }
      }).catch((error) => {
        // 请求失败时也要关闭loading
        console.error('获取案件列表失败:', error);
        this.loading = false;
        this.refreshing = false;
        this.$toast('加载失败，请重试');
      });
    }
  }
};
</script>

<style scoped lang="scss">
.backgroundBox {
    background: none!important;
  }
.main-contentBox {
  padding: 16px;
  width: 100%;
  height: auto;
  .search {
    display: flex;
    align-items: center;
    .back {
      margin-right: 12px;
    }
  }
  .re-contentBox {
    overflow: auto;
    min-height: 380px;
    margin-top: 16px;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    display: flex;
    justify-content: center;
    .textBox {
      width: 80%;
      .tiptext {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        line-height: 37px;
        margin-left: 5px;
      }
      .codebtn {
        width: 105px;
        height: 30px;
        background: #5a89fd;
        border-radius: 4px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        margin-top: 5px;
        margin-left: 10px;
        cursor: pointer;
      }
      .codebtn-gary {
        width: 105px;
        height: 30px;
        background: #ccc;
        border-radius: 4px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        margin-top: 5px;
        margin-left: 10px;
        cursor: not-allowed;
      }
    }
  }
  .list-section {
  width: 100%;
  padding-bottom: 16px;
  position: relative;
  top: 16px;
}

.list-section .list-item {
  width: 100%;
  /* height: 57.6vw; */
  margin: 0 auto 2.8vw;
  background-color: #fff;
  border-radius: 2.13vw;
  padding: 2.53vw 0;
  box-sizing: border-box;
}
.list-section .list-item .top-btn {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 0 10px;
}
.list-section .list-item .item-status {
  /* width: 22.8vw;
  height: 4.8vw; */
  padding:10px;
  border-radius: 1.06vw;
  /* justify-content: center;
  align-items: center; */
  background-color: #468cd8;
  margin-left: 3.27vw;
  font-size: 3.2vw;
  color: #fff;
  /* min-width: 100rpx; */
  text-align: center;
  float: right;
}

.list-section .list-item .item-title {
  width: 100%;
  padding: 2vw 3.27vw 0 3.27vw;
  box-sizing: border-box;
  font-size: 3.73vw;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-section .list-item .item-cell {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3.27vw;
  box-sizing: border-box;
  margin-top: 1.4vw;
}

.list-section .list-item .item-cell .item-cell-label {
  font-size: 3.2vw;
  color: #999;
  width: 20vw;
  text-align: left;
}

.list-section .list-item .item-cell .item-cell-content {
  font-size: 3.2vw;
  color: #666;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-section .list-item .item-foot {
  width: 100%;
  height: 10vw;
  border-top: .133vw solid #e5e5e5;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 3vw;
}

.list-section .list-item .item-foot .add-check-btn {
  width: 16.93vw;
  height: 7.46vw;
  border-radius: 1.06vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  color: #1C72FD;
  font-size: 3.47vw;
  margin-left: 3.33vw;
  border: 1px solid #1C72FD;
}

.list-section .list-item .item-foot .add-btn {
  width: 16.93vw;
  height: 7.46vw;
  border-radius: 1.06vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background:  #fff;
  color: #1C72FD;
  font-size: 3.47vw;
  margin-left: 3.33vw;
  border: 1px solid #1C72FD;
}
// 已补充过：补充按钮置灰
.list-section .list-item .item-foot .add-btn.add-btn-disabled {
  color: #c0c4cc;
  border-color: #dcdfe6;
  background: #f5f7fa;
}
// 已提交补正：补正按钮置灰
.list-section .list-item .item-foot .add-check-btn.add-check-btn-disabled {
  color: #c0c4cc;
  border-color: #dcdfe6;
  background: #f5f7fa;
}

.bzlabel {
  width: 24vw!important;
}
.diaslbed ::v-deep  .van-dialog__confirm:active {
  color:#999
}

}

.review-status-wrapper {
  position: relative;
  float: right;
}

.review-tip {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 50vw;
  padding: 2.5vw 3vw;
  box-sizing: border-box;
  font-size: 3vw;
  color: #333;
  text-align: left;
  line-height: 1.6;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  animation: fadeIn 0.3s ease-in-out;
}

.review-tip::before {
  content: '';
  position: absolute;
  top: -8px;
  right: 30px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #e5e5e5;
}

.review-tip::after {
  content: '';
  position: absolute;
  top: -6px;
  right: 31px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 驳回理由弹窗样式 */
.reject-dialog {
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
}

.reject-dialog-header {
  position: relative;
  padding: 30px 20px 10px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.reject-dialog-close {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}

.reject-dialog-content {
  padding: 10px 30px 40px;
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  text-align: left;
  max-height: 65vh;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-all;
  .title {
    text-align: center;
  }
}

::v-deep .van-tabs__nav {
  background-color: transparent!important;
}

// 听取意见弹窗样式
::v-deep .opinion-dialog {
  width: 90% !important;
  max-width: 500px;
  .van-dialog__content {
    padding: 0 16px;
    max-height: 70vh;
    overflow-y: auto;
  }
}

.opinion-dialog-body {
  font-size: 14px;
  color: #303133;
}

.opinion-question {
  margin: 16px 0px;
  line-height: 24px;
}

.opinion-tip-question {
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.opinion-question-content {
  color: #606266;
  padding: 8px 12px;
  border-radius: 4px;
}

.opinion-form-item {
  margin-bottom: 16px;
}
.opinion-upload-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.opinion-label {
  margin-bottom: 8px;
  font-weight: 500;
  color: #303133;
}

.required-star {
  color: #f56c6c;
  margin-right: 4px;
}

.opinion-textarea {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 8px;
  margin-top: 8px;
}

.file-list {
  margin-top: 8px;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 8px;
}

.file-name {
  flex: 1;
  font-size: 14px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}

.file-status {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
  flex-shrink: 0;
}

.file-status.success {
  color: #67c23a;
}

.file-delete {
  color: #909399;
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
}
.opinion-upload-button{
  height: 26px;
  padding: 0 18px;
  border-radius: 4px;
  font-weight: 400;
  border: none;
  background: linear-gradient(90deg,#5a9cff,#4486ff);
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.opinion-upload-tip {
  margin-left: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 18px;
}

.opinion-checkbox {
  ::v-deep .van-checkbox__label {
    font-size: 12px;
    color: #303133;
    line-height: 20px;
  }
}
</style>
